var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoHeader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 114.097,
    height: 42.088,
    viewBox: "0 0 114.097 42.088",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:url(#a);}.b{fill:url(#b);}.c{fill:url(#c);}.d{fill:url(#d);}.e{fill:url(#e);}.f{fill:url(#f);}.g{fill:url(#g);}.h{fill:url(#h);}.i{fill:url(#i);}.j{fill:url(#j);}.k{fill:url(#k);}.l{fill:#0c8591;}.m{fill:#d99448;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: -1.525,
    y1: -3.681,
    x2: 1.086,
    y2: 1.711,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4c8794"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2f4e90"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: -1.006,
    y1: -2.599,
    x2: 1.614,
    y2: 2.793,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: -1.267,
    y1: -2.269,
    x2: 2.101,
    y2: 3.294,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: -1.907,
    y1: -3.291,
    x2: 1.506,
    y2: 2.09,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: -1.286,
    y1: -3.248,
    x2: 2.085,
    y2: 3.831,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: -1.235,
    y1: -2.849,
    x2: 2.392,
    y2: 4.398,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: -2.121,
    y1: -3.059,
    x2: 1.61,
    y2: 2.548,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: -0.713,
    y1: -2.214,
    x2: 2.657,
    y2: 4.899,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: -0.835,
    y1: -1.169,
    x2: 3.609,
    y2: 4.242,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: -1.863,
    y1: -6.105,
    x2: 6.123,
    y2: 16.22,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 0.82,
    y1: 1.52,
    x2: 0.431,
    y2: 0.091,
    xlinkHref: "#a"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-181.048 -348.564)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(224.259 351.375)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1036.366,550.578a7.669,7.669,0,1,1-7.741,7.689A7.607,7.607,0,0,1,1036.366,550.578Zm-.031,3.71a3.952,3.952,0,0,0,.023,7.9,3.953,3.953,0,0,0-.023-7.9Z",
    transform: "translate(-973.188 -529.877)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M666.868,558.264a7.7,7.7,0,1,1,7.678,7.658A7.52,7.52,0,0,1,666.868,558.264Zm11.542.034a3.85,3.85,0,0,0-3.8-4,3.953,3.953,0,1,0,3.8,4Z",
    transform: "translate(-653.535 -529.883)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M561.556,559.157a3.783,3.783,0,0,1,2.408,2.167,4.193,4.193,0,0,1-3.325,5.865,82.9,82.9,0,0,1-8.328.06V552.479h.953c1.846,0,3.694-.039,5.538.018a7.122,7.122,0,0,1,2.423.406,3.4,3.4,0,0,1,.691,6.063C561.835,559.012,561.753,559.053,561.556,559.157Zm-3.953,5a14.571,14.571,0,0,0,1.549-.092,1.383,1.383,0,0,0,1.264-1.514,1.409,1.409,0,0,0-1.445-1.353c-.611-.035-1.226-.024-1.838-.017-1.42.015-1.208-.181-1.217,1.247C555.9,564.137,555.913,564.137,557.6,564.162ZM555.92,555.7c0,.756-.013,1.457.013,2.156,0,.114.181.319.275.317a22.324,22.324,0,0,0,2.75-.13,1.046,1.046,0,0,0,.866-1.207,1.1,1.1,0,0,0-1.007-1.114C557.885,555.645,556.941,555.7,555.92,555.7Z",
    transform: "translate(-552.311 -531.545)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M926.115,555.177a31.057,31.057,0,0,0-3.251-.934c-1.063-.188-1.731.171-1.871.737s.258.941,1.37,1.355c.862.321,1.733.622,2.585.97,2.083.852,2.984,2.086,2.969,4.018a4.444,4.444,0,0,1-3.019,4.2,8.228,8.228,0,0,1-8.489-1.745c-.1-.1-.181-.21-.308-.358l1.824-2.684c.195.146.36.26.515.387A5.8,5.8,0,0,0,921.5,562.5a3.25,3.25,0,0,0,1.459-.107,1.344,1.344,0,0,0,.769-.86,1.178,1.178,0,0,0-.589-.908,24.67,24.67,0,0,0-2.363-.936c-.352-.136-.706-.27-1.05-.423a4.2,4.2,0,0,1-2.744-4.07,4.4,4.4,0,0,1,3.008-4.063,7.736,7.736,0,0,1,7.324,1.128.651.651,0,0,1,.191.6C927.037,553.7,926.518,554.514,926.115,555.177Z",
    transform: "translate(-873.759 -529.957)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(28.867 4.923)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M915.988,426.814a5.843,5.843,0,1,1,5.985-5.785A5.679,5.679,0,0,1,915.988,426.814Zm-.026-3.3a2.5,2.5,0,0,0,2.515-2.526,2.479,2.479,0,1,0-4.958-.065A2.5,2.5,0,0,0,915.962,423.514Z",
    transform: "translate(-897.244 -415.119)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M803.75,415.337v1.341c.207-.169.33-.253.433-.356a4.121,4.121,0,0,1,4.632-.985,3.757,3.757,0,0,1,2.591,3.625c.082,2.445.021,4.895.021,7.405h-3.432c-.012-.266-.032-.517-.032-.768,0-1.674.031-3.348-.013-5.021-.049-1.868-1.411-2.82-2.9-2.063a2.187,2.187,0,0,0-1.17,2.11c-.013,1.65,0,3.3-.005,4.95,0,.254,0,.508,0,.85-1.106,0-2.14.017-3.171-.021-.128,0-.353-.295-.354-.453q-.03-5.056,0-10.112c0-.168.251-.473.4-.48C801.708,415.316,802.675,415.337,803.75,415.337Z",
    transform: "translate(-800.33 -415.019)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M829.325,564.218v3.558H818.518V553.027h3.674v11.191Z",
    transform: "translate(-787.534 -532.041)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M644.355,416.508l.106-.886c.979,0,1.942-.018,2.9.022.125.005.342.3.343.464q.031,5.051,0,10.1c0,.168-.253.471-.4.478-.938.044-1.88.022-2.851.022l-.08-.636a12.342,12.342,0,0,1-2.635.86,5.085,5.085,0,0,1-5.71-3.981,6.124,6.124,0,0,1,1.177-5.847,5.082,5.082,0,0,1,6.728-.878C644.049,416.3,644.162,416.378,644.355,416.508Zm-2.508,2.081a2.578,2.578,0,0,0-.041,5.155,2.578,2.578,0,0,0,.041-5.155Z",
    transform: "translate(-626.046 -410.378)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M560.644,396c.244.722.529,1.469.733,2.238a.736.736,0,0,1-.27.65,6.67,6.67,0,0,1-4.211.593,3.392,3.392,0,0,1-2.847-3.188c-.114-1.05-.1-2.115-.132-3.173-.017-.61,0-1.222,0-1.918l-1.6-.084v-2.9h1.674v-3.907h3.452v3.876h3.419v2.945H557.4c.067,1.492.091,2.913.216,4.327a.949.949,0,0,0,1.065.845C559.309,396.261,559.926,396.113,560.644,396Z",
    transform: "translate(-552.311 -382.958)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M680.625,372.721c-.627,1.231-1.183,2.342-1.767,3.437a.611.611,0,0,1-.451.25c-.9.024-1.791.012-2.832.012.424-1.226.807-2.368,1.227-3.5.041-.111.309-.191.473-.194C678.338,372.712,679.4,372.721,680.625,372.721Z",
    transform: "translate(-661.228 -372.718)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(181.048 348.564)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 5.456)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M212.7,421.2l-15.965-10.065v22.775l16.1,10.2,16.1-10.2V411.133Z",
    transform: "translate(-194.912 -409.306)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M198.979,432.074a1.826,1.826,0,0,1-.977-.284l-16.1-10.2a1.826,1.826,0,0,1-.849-1.543V397.268a1.826,1.826,0,0,1,2.8-1.545l15,9.457,15.273-9.464a1.826,1.826,0,0,1,2.788,1.552v22.775a1.826,1.826,0,0,1-.849,1.543l-16.1,10.2A1.826,1.826,0,0,1,198.979,432.074ZM184.7,419.039l14.278,9.047,14.278-9.047v-18.49L199.8,408.886a1.826,1.826,0,0,1-1.936-.008l-13.165-8.3Z",
    transform: "translate(-181.048 -395.442)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M267.6,356.935l2.973-1.806,6.035,3.771,2.308-3.693-6.149-3.842v-2.8H268.41v2.783l-6.093,3.7-.023,3.708,11.473,7.166-3.312,2.052-6.09-3.839-2.322,3.684,7.241,4.565,2.308.009,7.444-4.613.007-3.7Z",
    transform: "translate(-252.616 -348.564)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.586 7.001)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.383 9.659)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M327.708,492.676a.28.28,0,0,1-.15-.043l-.713-.449.3-.475.564.356.567-.351.3.478-.716.444A.281.281,0,0,1,327.708,492.676Z",
    transform: "translate(-326.845 -491.708)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.166 1.326)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M225.179,428.087l-1.322-.833.3-.475,1.322.833Zm-2.643-1.667-1.322-.833.3-.475,1.322.833Zm-2.643-1.667-1.322-.833.3-.475,1.322.833Zm-2.644-1.667-1.322-.833.3-.475,1.322.833Zm-2.644-1.667-1.322-.833.3-.475,1.322.833Z",
    transform: "translate(-213.283 -420.112)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M195.237,409.843h-.562V409a.281.281,0,0,1,.431-.238l.713.45-.3.475-.282-.178Z",
    transform: "translate(-194.675 -408.719)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 2.746)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M195.237,450.158h-.562v-1.622h.562Zm0-3.244h-.562v-1.622h.562Zm0-3.245h-.562v-1.622h.562Zm0-3.244h-.562V438.8h.562Zm0-3.244h-.562v-1.622h.562Zm0-3.244h-.562v-1.622h.562Z",
    transform: "translate(-194.675 -432.313)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 22.213)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M195.518,601.1l-.712-.451a.281.281,0,0,1-.131-.237v-.843h.562v.688l.581.368Z",
    transform: "translate(-194.675 -599.571)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.177 24.115)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M225.391,624l-1.335-.846.3-.475,1.335.846Zm-2.669-1.691-1.335-.846.3-.475,1.335.846Zm-2.669-1.691-1.335-.846.3-.475,1.335.846Zm-2.669-1.691-1.335-.846.3-.475,1.335.846Zm-2.669-1.691-1.335-.846.3-.475,1.335.846Z",
    transform: "translate(-213.38 -615.915)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.523 32.572)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M328.908,689.542a.28.28,0,0,1-.15-.044l-.712-.451.3-.475.561.356.562-.356.3.475-.712.451A.281.281,0,0,1,328.908,689.542Z",
    transform: "translate(-328.046 -688.573)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(18.281 24.115)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M352.047,624l-.3-.475,1.334-.846.3.475Zm2.669-1.691-.3-.475,1.334-.846.3.475Zm2.669-1.691-.3-.475,1.335-.846.3.475Zm2.669-1.691-.3-.475,1.335-.846.3.475Zm2.669-1.691-.3-.475,1.335-.846.3.475Z",
    transform: "translate(-351.746 -615.914)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(31.627 22.213)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M466.713,601.1l-.3-.475.581-.368v-.688h.562v.843a.281.281,0,0,1-.131.237Z",
    transform: "translate(-466.412 -599.571)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(32.209 2.746)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M471.969,450.158h-.562v-1.622h.562Zm0-3.244h-.562v-1.622h.562Zm0-3.245h-.562v-1.622h.562Zm0-3.244h-.562V438.8h.562Zm0-3.244h-.562v-1.622h.562Zm0-3.244h-.562v-1.622h.562Z",
    transform: "translate(-471.407 -432.313)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(31.625)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M467.54,409.843h-.562V409.5l-.288.178-.3-.478.716-.444a.281.281,0,0,1,.429.239Z",
    transform: "translate(-466.395 -408.719)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(18.161 1.32)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M351.007,428.049l-.3-.478,1.346-.834.3.478Zm2.693-1.669-.3-.478,1.347-.834.3.478Zm2.693-1.669-.3-.478,1.346-.834.3.478Zm2.693-1.669-.3-.478,1.346-.834.3.478Zm2.693-1.669-.3-.478,1.346-.834.3.478Z",
    transform: "translate(-350.711 -420.063)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoHeader);
export default __webpack_public_path__ + "static/media/logo_header.37aee481dc026f8ba4eddac8c25732ba.svg";
export { ForwardRef as ReactComponent };